module.exports = __webpack_public_path__ + "static/img/culture-3.2c6a99c9.png";